//NOTE autogenerated by export script
export {BffOofWebService as BffOofWeb} from './bffOofWeb.service'
export {ConfigTemplatesCustomerAPIService as ConfigTemplatesCustomer} from './configTemplatesCustomerAPI.service'
export {MeUserService as MeUser} from './meUser.service'
export {OrderItemConfigurationsService as OrderItemConfigurations} from './orderItemConfigurations.service'
export {OrderItemDevicesService as OrderItemDevices} from './orderItemDevices.service'
export {OrderItemsService as OrderItems} from './orderItems.service'
export {OrdersService as Orders} from './orders.service'
export {RmaCustomerService as RmaCustomer} from './rmaCustomer.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AllServices as All} from './allService'